import React, { Component } from 'react';
import { detect } from 'detect-browser';
import { IHttpApi } from '@cian/http-api';
import { mergeStyles } from '@cian/utils/lib/shared/style';
import { PushManager, PopupManager, EMessageResponseTypes } from '@cian/push-manager';
import {
  trackingShowSubscribeNotifications,
  trackingClickSubscribeNotifications,
} from '../NotificationCenter/tracking';

interface INotificationWithPushProps {
  subdomain: string;
  httpApi?: IHttpApi;
  applicationServerKey: string;
  pushBrowserUrl: string;
  setShowNotification(show: boolean): void;
}

interface IStateProps {
  isSubscribed: boolean;
}

export class NotificationWithPush extends Component<INotificationWithPushProps, IStateProps> {
  public state = {
    isSubscribed: true,
  };

  private pushManager = new PushManager({
    baseUrl: this.props.pushBrowserUrl,
    hasSubdomain: this.props.subdomain !== 'www',
  });

  public componentDidMount() {
    if (this.canShow()) {
      trackingShowSubscribeNotifications();
    }
    this.pushManager.registerWorker();
    PushManager.ready().then(PushManager.checkSubscription);

    window.addEventListener('message', this.setSubscriptionHandler);
  }

  public componentWillUnmount() {
    window.removeEventListener('message', this.setSubscriptionHandler);
  }

  private setSubscriptionHandler = (e: MessageEvent) => {
    const { setShowNotification } = this.props;

    if (!this.canShow()) {
      setShowNotification(false);

      return;
    }

    try {
      const data = JSON.parse(e.data);

      if (data.type === EMessageResponseTypes.subscriptionStatus && !data.value) {
        this.setState({ isSubscribed: data.value }, () => {
          setShowNotification(!data.value);
        });
      }
    } catch (e) {}
  };

  private canShow = () => {
    const browser = detect();

    return (
      browser && !['safari', 'firefox'].includes(browser.name) && !['Android OS', 'iOS'].includes(browser.os || '')
    );
  };

  private submit = async () => {
    const { subdomain, httpApi, applicationServerKey, setShowNotification } = this.props;
    trackingClickSubscribeNotifications();

    if (subdomain !== 'www') {
      // eslint-disable-next-line no-unused-expressions
      this.pushManager.showPopup({
        baseUrl: 'web-push-subscribe-popup',
      });
    } else if (applicationServerKey && httpApi) {
      const popup = new PopupManager({
        workerSrc: '/push-worker.js',
        applicationServerKey,
        httpApi,
      });
      try {
        await popup.register();
      } catch (error) {
        return;
      }

      try {
        await popup.subscribe();
        this.setState({ isSubscribed: true });
        setShowNotification(false);
      } catch (error) {
        return;
      }
    }
  };

  public render() {
    const { isSubscribed } = this.state;

    return !isSubscribed && this.canShow() ? (
      <div
        {...mergeStyles(
          'c-notification-center__block c-notification-center__block--notification',
          'c-notification-center__block c-notification-center__block--with-push',
        )}
        onClick={this.submit}
      >
        <div className="c-notification-center__content">
          <p className="c-notification-center__title c-notification-center__title--in-push">
            У вас выключены push-уведомления
          </p>
          <p className="c-notification-center__description c-notification-center__description--in-push">
            О новых предложениях, изменении цены и персональных рекомендациях
          </p>
        </div>
        <button className="c-notification-button">Включить</button>
      </div>
    ) : null;
  }
}
